import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import Avatar from 'material-ui/Avatar';
import  Chip  from 'material-ui/Chip';
import { statusColours } from '../../constants/ColourConstants';

const styles = {
    chip: {
        margin: 4,
    },
};


const Chipy = (props) => {

    let backgroundColor = null;
    let avatarBackgroundColor = null;

    if (props.disabled === true) {
         backgroundColor = statusColours.disabled;
         avatarBackgroundColor = statusColours.disabled;
    } else {

        switch(props.theme) {

            case 'primary':
                backgroundColor = statusColours.primary_4;
                avatarBackgroundColor = statusColours.primary;
                break;

            case 'secondary':
                backgroundColor = statusColours.secondary_o;
                avatarBackgroundColor = statusColours.secondary;
                break;

            default:
                break;
        }
    }

    let avatar;
    if (!!props.avatar) {
        avatar = <Avatar size={30} icon={props.avatar} backgroundColor={avatarBackgroundColor} />;
    }

    const label = !props.url ? props.label :  <Link to={props.url} target={props.target} >{props.label}</Link>;

    return (
        <Chip
            backgroundColor={backgroundColor}
            style={styles.chip}
            onRequestDelete={props.onDelete}
        >
            {avatar}{label}
        </Chip>
    );
};

Chip.propTypes = {
    label: PropTypes.string,
    avatar: PropTypes.object,
    url: PropTypes.string,
    target: PropTypes.string,
    onDelete: PropTypes.func,
    disabled: PropTypes.bool,
    theme: PropTypes.string,
};

export default Chipy;
